import ServerApi from './$server.api'

export default {
    getZipcode
}

async function getZipcode(zipcode) {
    return await ServerApi.request('get', `/zipcodes/${ zipcode }`)
}